<div class="dialog-container">
    <div class="dialog-close">
        <div id="btn-cancel" class="fab small active" (click)="onNoClick()">
            <i class="fas fa-times"></i>
        </div>
    </div>
    @if (!type() && !group()) {
        <h1 class="condensed dialog-title">Type</h1>
        <div class="dialog-content">
            <table class="table table-hover curpoint w-100">
                @for (type of types(); track type) {
                    <tr (click)="filterType(type)">
                        <td>
                            {{type}} @if (type == 'Lengtemarkering' && !lengthmark) {
                            <span>(kort)</span>
                        }
                        </td>
                    </tr>
                }
            </table>
        </div>
    }
    @if (!pushpinPart.material_id && type()) {
        <h1 class="condensed dialog-title">Materiaal</h1>
        <div class="dialog-content">
            <table class="table table-hover curpoint w-100">
                @for (material of materials(); track material) {
                    <tr (click)="selectMaterial(material)">
                        <td>
                            {{material.name}}
                        </td>
                    </tr>
                }
            </table>
        </div>
    }
    @if (pushpinPart.material_id && type() && !group()) {
        <h1 class="condensed dialog-title">Groep</h1>
        <div class="dialog-content">
            <table class="table table-hover curpoint w-100">
                @for (group of groups(); track group) {
                    <tr (click)="filterGroup(group)">
                        <td>
                            {{group}}
                        </td>
                    </tr>
                }
            </table>
        </div>
    }
    @if (type() && group() && !pushpinPart.decoration && pushpinPart.material_id) {
        <h1 class="condensed dialog-title">{{group()}}</h1>
        <div class="dialog-content">
            <table class="table table-hover curpoint w-100">
                @for (decoration of decorations(); track decoration) {
                    <tr (click)="selectDecoration(decoration)">
                        <td>
                            {{decoration.name}}
                        </td>
                    </tr>
                }
            </table>
        </div>
    }
    @if (pushpinPart.decoration && pushpinPart.material_id) {
        <h1 class="condensed dialog-title">Aantal</h1>
        <div class="dialog-content flex-column">
            <div class="amount-selection">
                <div class="amount">
                    <div>&nbsp;</div>
                </div>
                <div class="amount">
                    <div class="number-input">{{amountInput()}}</div>
                </div>
                <div class="amount click" (click)="backspaceAmountInput()">
                    <div>
                        <i class="fas fa-backspace"></i>
                    </div>
                </div>
                @for (amount of amountsList(); track amount) {
                    <div (click)="setAmountInput(amount)" class="amount click">
                        <div>{{amount}}</div>
                    </div>
                }
                <div class="amount click">
                    <div>&nbsp;</div>
                </div>
                <div class="amount click" (click)="setAmountInput(0)">
                    <div>0</div>
                </div>
                <div (click)="selectAmount(amountInput())" class="amount confirm">
                    <button color="primary" mat-raised-button>OK</button>
                </div>
            </div>
        </div>
    }
    <div class="d-none d-sm-block">
        @if (type() && !lengthmark) {
            <button (click)="breadcrumBack(0)" mat-button>{{type()}}</button>
        }
        @if (pushpinPart.material_id) {
            /
            <button (click)="breadcrumBack(1)" mat-button>{{pushpinPart.material.name}}</button>
        }
        @if (group() && pushpinPart.material_id && group() != 'Lengtemarkering') {
            /
            <button (click)="breadcrumBack(2)" mat-button>{{group()}}</button>
        }
        @if (pushpinPart.decoration) {
            /
            <button (click)="breadcrumBack(3)" mat-button>{{pushpinPart.decoration.name}}</button>
        }
    </div>
</div>
